import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { SITE_WOWCHER, SITE_WOWCHERIE } from '../../../config/setup/setup';
import { hashCode } from '../../../helpers/hash';

const VoucherStatus = ({ list, site = SITE_WOWCHER }) => {
  return (
    <>
      <ul className="voucher-status">
        {list.map((item, index) => (
          <li
            className="voucher-status__item"
            key={`voucher-status--${hashCode()}-${index}`}
          >
            <div
              className={classNames('voucher-status__title', {
                'text-lowercase':
                  site !== SITE_WOWCHER && site !== SITE_WOWCHERIE,
              })}
            >
              {item.title}
            </div>
            <div className="voucher-status__desc">{item.desc}</div>
          </li>
        ))}
      </ul>
      <style jsx>{`
        .voucher-status {
          list-style: none;
          padding: 0;
        }
        .voucher-status__item {
          margin-bottom: 10px;
        }
        .voucher-status__title {
          font-weight: 700;
        }
      `}</style>
    </>
  );
};

VoucherStatus.propTypes = {
  list: PropTypes.array.isRequired,
  site: PropTypes.string,
};

export default VoucherStatus;
